//// -------- DEV --------
// export const apiUrl = "http://localhost:8094/api/v1";
// export const imageUrl = "http://localhost:8094";
// //// -------- END DEV --------

//// -------- Training --------
export const apiUrl = "https://access.jaspal.co.th:8103/api/v1";
export const imageUrl = "https://access.jaspal.co.th:8103";

export const YES = "YES";
export const NO = "NO";
export const OK = "ok";
export const NOK = "nok";

export const GET_APPROVER_FETCH = "GET_APPROVER_FETCH";
export const GET_APPROVER_SUCCESS = "GET_APPROVER_SUCCESS";
export const GET_APPROVER_REJECTED = "GET_APPROVER_REJECTED";
export const GET_APPROVERS_FETCH = "GET_APPROVERS_FETCH";
export const GET_APPROVERS_SUCCESS = "GET_APPROVERS_SUCCESS";
export const GET_APPROVERS_REJECTED = "GET_APPROVERS_REJECTED";

export const GET_CEOS_FETCH = "GET_CEOS_FETCH";
export const GET_CEOS_SUCCESS = "GET_CEOS_SUCCESS";
export const GET_CEOS_REJECTED = "GET_CEOS_REJECTED";

export const CREATE_BG_ADJ_SUCCESS = "CREATE_BG_ADJ_SUCCESS";
export const CREATE_BG_ADJ_REJECTED = "CREATE_BG_ADJ_REJECTED";

export const UPDATE_BG_ADJ_SUCCESS = "UPDATE_BG_ADJ_SUCCESS";
export const UPDATE_BG_ADJ_REJECTED = "UPDATE_BG_ADJ_REJECTED";

export const GET_BG_ADJ_PROJECT_FETCH = "GET_BG_ADJ_PROJECT_FETCH";
export const GET_BG_ADJ_PROJECT_SUCCESS = "GET_BG_ADJ_PROJECT_SUCCESS";
export const GET_BG_ADJ_PROJECT_REJECTED = "GET_BG_ADJ_PROJECT_REJECTED";

export const GET_BG_ADJ_BUDGET_FETCH = "GET_BG_ADJ_BUDGET_FETCH";
export const GET_BG_ADJ_BUDGET_SUCCESS = "GET_BG_ADJ_BUDGET_SUCCESS";
export const GET_BG_ADJ_BUDGET_REJECTED = "GET_BG_ADJ_BUDGET_REJECTED";

export const GET_BG_ADJ_FETCH = "GET_BG_ADJ_FETCH";
export const GET_BG_ADJ_SUCCESS = "GET_BG_ADJ_SUCCESS";
export const GET_BG_ADJ_REJECTED = "GET_BG_ADJ_REJECTED";

export const AUTHEN_FETCHING = "AUTHEN_FETCHING";
export const AUTHEN_FAILED = "AUTHEN_FAILED";
export const AUTHEN_SUCCESS = "AUTHEN_SUCCESS";

export const LOGIN_FETCHING = "LOGIN_FETCHING";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const USER_BUDGET_PERMISSION_FETCHING =
  "USER_BUDGET_PERMISSION_FETCHING";
export const USER_BUDGET_PERMISSION_SUCCESS = "USER_BUDGET_PERMISSION_SUCCESS";
export const USER_BUDGET_PERMISSION_FAIL = "USER_BUDGET_PERMISSION_FAIL";

export const USER_PR_PERMISSION_FETCHING = "USER_PR_PERMISSION_FETCHING";
export const USER_PR_PERMISSION_SUCCESS = "USER_PR_PERMISSION_SUCCESS";
export const USER_PR_PERMISSION_FAIL = "USER_PR_PERMISSION_FAIL";

export const MENU_SYSTEM_FETCHING = "MENU_SYSTEM_FETCHING";
export const MENU_SYSTEM_SUCCESS = "MENU_SYSTEM_SUCCESS";
export const MENU_SYSTEM_FAIL = "MENU_SYSTEM_FAIL";

// // Brand Query
export const HTTP_SELBRAND_FETCHING = "HTTP_SELBRAND_FETCHING";
export const HTTP_SELBRAND_SUCCESS = "HTTP_SELBRAND_SUCCESS";
export const HTTP_SELBRAND_FAILED = "HTTP_SELBRAND_FAILED";
// export const STOCK_CLEAR = "STOCK_CLEAR";

// // Year Query
export const HTTP_YEAR_FETCHING = "HTTP_YEAR_FETCHING";
export const HTTP_YEAR_SUCCESS = "HTTP_YEAR_SUCCESS";
export const HTTP_YEAR_FAILED = "HTTP_YEAR_FAILED";

// // Company Query
export const HTTP_SELCOMPANY_FETCHING = "HTTP_SELCOMPANY_FETCHING";
export const HTTP_SELCOMPANY_SUCCESS = "HTTP_SELCOMPANY_SUCCESS";
export const HTTP_SELCOMPANY_FAILED = "HTTP_SELCOMPANY_FAILED";

// // Country Page
export const HTTP_COUNTRY_FETCHING = "HTTP_COUNTRY_FETCHING";
export const HTTP_COUNTRY_SUCCESS = "HTTP_COUNTRY_SUCCESS";
export const HTTP_COUNTRY_FAILED = "HTTP_COUNTRY_FAILED";

// // Department Page
export const HTTP_DEPARTMENT_FETCHING = "HTTP_DEPARTMENT_FETCHING";
export const HTTP_DEPARTMENT_SUCCESS = "HTTP_DEPARTMENT_SUCCESS";
export const HTTP_DEPARTMENT_FAILED = "HTTP_DEPARTMENT_FAILED";

// // Username Authen Page
export const HTTP_USERAUTH_FETCHING = "HTTP_USERAUTH_FETCHING";
export const HTTP_USERAUTH_SUCCESS = "HTTP_USERAUTH_SUCCESS";
export const HTTP_USERAUTH_FAILED = "HTTP_USERAUTH_FAILED";
export const HTTP_USERAUTH_CLEAR = "HTTP_USERAUTH_CLEAR";

// // Budget 5 param Page
export const HTTP_BUDGETS_FETCHING = "HTTP_BUDGETS_FETCHING";
export const HTTP_BUDGETS_SUCCESS = "HTTP_BUDGETS_SUCCESS";
export const HTTP_BUDGETS_FAILED = "HTTP_BUDGETS_FAILED";
export const HTTP_BUDGETS_RESET = "HTTP_BUDGETS_RESET";

// // Budget select 12 monthPage
export const HTTP_BUDGETMONTH_FETCHING = "HTTP_BUDGETMONTH_FETCHING";
export const HTTP_BUDGETMONTH_SUCCESS = "HTTP_BUDGETMONTH_SUCCESS";
export const HTTP_BUDGETMONTH_FAILED = "HTTP_BUDGETMONTH_FAILED";

// // Budget Update 12 month
export const HTTP_UPDATEBUDGETMONTH_FETCHING =
  "HTTP_UPDATEBUDGETMONTH_FETCHING";
export const HTTP_UPDATEBUDGETMONTH_SUCCESS = "HTTP_UPDATEBUDGETMONTH_SUCCESS";
export const HTTP_UPDATEBUDGETMONTH_FAILED = "HTTP_UPDATEBUDGETMONTH_FAILED";

// // Budget Insert BUDGETS_S
export const HTTP_INSERTBUDGET_FETCHING = "HTTP_INSERTBUDGET_FETCHING";
export const HTTP_INSERTBUDGET_SUCCESS = "HTTP_INSERTBUDGET_SUCCESS";
export const HTTP_INSERTBUDGET_FAILED = "HTTP_INSERTBUDGET_FAILED";

// // Budget Insert PROJECT
export const HTTP_INSERTPROJECT_FETCHING = "HTTP_INSERTPROJECT_FETCHING";
export const HTTP_INSERTPROJECT_SUCCESS = "HTTP_INSERTPROJECT_SUCCESS";
export const HTTP_INSERTPROJECT_FAILED = "HTTP_INSERTPROJECT_FAILED";

// // Budget Update PROJECT
export const HTTP_UPDATEPROJECT_FETCHING = "HTTP_UPDATEPROJECT_FETCHING";
export const HTTP_UPDATEPROJECT_SUCCESS = "HTTP_UPDATEPROJECT_SUCCESS";
export const HTTP_UPDATEPROJECT_FAILED = "HTTP_UPDATEPROJECT_FAILED";

// // Budget Get PROJECT
export const HTTP_GETPROJECT_FETCHING = "HTTP_GETPROJECT_FETCHING";
export const HTTP_GETPROJECT_SUCCESS = "HTTP_GETPROJECT_SUCCESS";
export const HTTP_GETPROJECT_FAILED = "HTTP_GETPROJECT_FAILED";

// // Budget Get PROJECT
export const HTTP_GETPROJECTDETAIL_FETCHING = "HTTP_GETPROJECTDETAIL_FETCHING";
export const HTTP_GETPROJECTDETAIL_SUCCESS = "HTTP_GETPROJECTDETAIL_SUCCESS";
export const HTTP_GETPROJECTDETAIL_FAILED = "HTTP_GETPROJECTDETAIL_FAILED";

// // Budget Update PROJECT
export const HTTP_UPDATEPROJECTDETAIL_FETCHING =
  "HTTP_UPDATEPROJECTDETAIL_FETCHING";
export const HTTP_UPDATEPROJECTDETAIL_SUCCESS =
  "HTTP_UPDATEPROJECTDETAIL_SUCCESS";
export const HTTP_UPDATEPROJECTDETAIL_FAILED =
  "HTTP_UPDATEPROJECTDETAIL_FAILED";

// // Budget 5 param  SID
export const HTTP_BUDGETSSID_FETCHING = "HTTP_BUDGETSSID_FETCHING";
export const HTTP_BUDGETSSID_SUCCESS = "HTTP_BUDGETSSID_SUCCESS";
export const HTTP_BUDGETSSID_FAILED = "HTTP_BUDGETSSID_FAILED";

// // Budget Delete Project
export const HTTP_DELETEPROJECT_FETCHING = "HTTP_DELETEPROJECT_FETCHING";
export const HTTP_DELETEPROJECT_SUCCESS = "HTTP_DELETEPROJECT_SUCCESS";
export const HTTP_DELETEPROJECT_FAILED = "HTTP_DELETEPROJECT_FAILED";

// // Budget Get File
export const HTTP_GETFILES_FETCHING = "HTTP_GETFILES_FETCHING";
export const HTTP_GETFILES_SUCCESS = "HTTP_GETFILES_SUCCESS";
export const HTTP_GETFILES_FAILED = "HTTP_GETFILES_FAILED";

// // Budget Get BU Head
export const HTTP_GETBUHEAD_FETCHING = "HTTP_GETBUHEAD_FETCHING";
export const HTTP_GETBUHEAD_SUCCESS = "HTTP_GETBUHEAD_SUCCESS";
export const HTTP_GETBUHEAD_FAILED = "HTTP_GETBUHEAD_FAILED";

// // Budget Update BUHEAD
export const HTTP_UPDATEBUHEAD_FETCHING = "HTTP_UPDATEBUHEAD_FETCHING";
export const HTTP_UPDATEBUHEAD_SUCCESS = "HTTP_UPDATEBUHEAD_SUCCESS";
export const HTTP_UPDATEBUHEAD_FAILED = "HTTP_UPDATEBUHEAD_FAILED";

// // Budget Get Approve
export const HTTP_GETAPPROVE_FETCHING = "HTTP_GETAPPROVE_FETCHING";
export const HTTP_GETAPPROVE_SUCCESS = "HTTP_GETAPPROVE_SUCCESS";
export const HTTP_GETAPPROVE_FAILED = "HTTP_GETAPPROVE_FAILED";

// // Budget Get Approve History
export const HTTP_GETAPPROVEHISTORY_FETCHING =
  "HTTP_GETAPPROVEHISTORY_FETCHING";
export const HTTP_GETAPPROVEHISTORY_SUCCESS = "HTTP_GETAPPROVEHISTORY_SUCCESS";
export const HTTP_GETAPPROVEHISTORY_FAILED = "HTTP_GETAPPROVEHISTORY_FAILED";

// // Budget Update Approve
export const HTTP_UPDATEAPPROVE_FETCHING = "HTTP_UPDATEAPPROVE_FETCHING";
export const HTTP_UPDATEAPPROVE_SUCCESS = "HTTP_UPDATEAPPROVE_SUCCESS";
export const HTTP_UPDATEAPPROVE_FAILED = "HTTP_UPDATEAPPROVE_FAILED";

// // Budget Reject Approve
export const HTTP_REJECTAPPROVE_FETCHING = "HTTP_REJECTAPPROVE_FETCHING";
export const HTTP_REJECTAPPROVE_SUCCESS = "HTTP_REJECTAPPROVE_SUCCESS";
export const HTTP_REJECTAPPROVE_FAILED = "HTTP_REJECTAPPROVE_FAILED";

// // Budget Get Budgets Detail
export const HTTP_GETBUDGETSDETAIL_FETCHING = "HTTP_GETBUDGETSDETAIL_FETCHING";
export const HTTP_GETBUDGETSDETAIL_SUCCESS = "HTTP_GETBUDGETSDETAIL_SUCCESS";
export const HTTP_GETBUDGETSDETAIL_FAILED = "HTTP_GETBUDGETSDETAIL_FAILED";

// // Report Manager By Brand
export const HTTP_REPORTMANAGERBYBRAND_FETCHING =
  "HTTP_REPORTMANAGERBYBRAND_FETCHING";
export const HTTP_REPORTMANAGERBYBRAND_SUCCESS =
  "HTTP_REPORTMANAGERBYBRAND_SUCCESS";
export const HTTP_REPORTMANAGERBYBRAND_FAILED =
  "HTTP_REPORTMANAGERBYBRAND_FAILED";

// // Report Manager By Department
export const HTTP_REPORTMANAGERBYDEPTS_FETCHING =
  "HTTP_REPORTMANAGERBYDEPTS_FETCHING";
export const HTTP_REPORTMANAGERBYDEPTS_SUCCESS =
  "HTTP_REPORTMANAGERBYDEPTS_SUCCESS";
export const HTTP_REPORTMANAGERBYDEPTS_FAILED =
  "HTTP_REPORTMANAGERBYDEPTS_FAILED";

// // Budget Get Budgets Detail REPORT
export const HTTP_GETBUDGETSDETAILREPORT_FETCHING =
  "HTTP_GETBUDGETSDETAILREPORT_FETCHING";
export const HTTP_GETBUDGETSDETAILREPORT_SUCCESS =
  "HTTP_GETBUDGETSDETAILREPORT_SUCCESS";
export const HTTP_GETBUDGETSDETAILREPORT_FAILED =
  "HTTP_GETBUDGETSDETAILREPORT_FAILED";
export const HTTP_RESET_BUDGETSDETAILREPORT = "HTTP_RESET_BUDGETSDETAILREPORT";

// // Budget Get Budgets Detail REPORT
export const HTTP_SENDEMAILBUHEAD_FETCHING = "HTTP_SENDEMAILBUHEAD_FETCHING";
export const HTTP_SENDEMAILBUHEAD_SUCCESS = "HTTP_SENDEMAILBUHEAD_SUCCESS";
export const HTTP_SENDEMAILBUHEAD_FAILED = "HTTP_SENDEMAILBUHEAD_FAILED";

// // Budget Get forecast
export const HTTP_GETFORECASTLIST1_FETCHING = "HTTP_GETFORECASTLIST1_FETCHING";
export const HTTP_GETFORECASTLIST1_SUCCESS = "HTTP_GETFORECASTLIST1_SUCCESS";
export const HTTP_GETFORECASTLIST1_FAILED = "HTTP_GETFORECASTLIST1_FAILED";
export const HTTP_RESET_FORECASTLIST1 = "HTTP_RESET_FORECASTLIST1";
// // Budget Get forecast
export const HTTP_GETFORECASTLIST2_FETCHING = "HTTP_GETFORECASTLIST2_FETCHING";
export const HTTP_GETFORECASTLIST2_SUCCESS = "HTTP_GETFORECASTLIST2_SUCCESS";
export const HTTP_GETFORECASTLIST2_FAILED = "HTTP_GETFORECASTLIST2_FAILED";
export const HTTP_RESET_FORECASTLIST2 = "HTTP_RESET_FORECASTLIST2";

// // Budget Get forecast
export const HTTP_GETFORECASTLIST3_FETCHING = "HTTP_GETFORECASTLIST3_FETCHING";
export const HTTP_GETFORECASTLIST3_SUCCESS = "HTTP_GETFORECASTLIST3_SUCCESS";
export const HTTP_GETFORECASTLIST3_FAILED = "HTTP_GETFORECASTLIST3_FAILED";
export const HTTP_RESET_FORECASTLIST3 = "HTTP_RESET_FORECASTLIST3";


// // Budget Get forecast
export const HTTP_GETFORECASTLIST4_FETCHING = "HTTP_GETFORECASTLIST4_FETCHING";
export const HTTP_GETFORECASTLIST4_SUCCESS = "HTTP_GETFORECASTLIST4_SUCCESS";
export const HTTP_GETFORECASTLIST4_FAILED = "HTTP_GETFORECASTLIST4_FAILED";
export const HTTP_RESET_FORECASTLIST4 = "HTTP_RESET_FORECASTLIST4";

// // Budget Get forecast
export const HTTP_GETFORECASTLIST5_FETCHING = "HTTP_GETFORECASTLIST5_FETCHING";
export const HTTP_GETFORECASTLIST5_SUCCESS = "HTTP_GETFORECASTLIST5_SUCCESS";
export const HTTP_GETFORECASTLIST5_FAILED = "HTTP_GETFORECASTLIST5_FAILED";
export const HTTP_RESET_FORECASTLIST5 = "HTTP_RESET_FORECASTLIST5";


// // Budget Update forecast
export const HTTP_UPDATEFORECASTLIST_FETCHING =
  "HTTP_UPDATEFORECASTLIST_FETCHING";
export const HTTP_UPDATEFORECASTLIST_SUCCESS =
  "HTTP_UPDATEFORECASTLIST_SUCCESS";
export const HTTP_UPDATEFORECASTLIST_FAILED = "HTTP_UPDATEFORECASTLIST_FAILED";

// // Budget Get Budget status
export const HTTP_GETBUDGETSTATUS_FETCHING = "HTTP_GETBUDGETSTATUS_FETCHING";
export const HTTP_GETBUDGETSTATUS_SUCCESS = "HTTP_GETBUDGETSTATUS_SUCCESS";
export const HTTP_GETBUDGETSTATUS_FAILED = "HTTP_GETBUDGETSTATUS_FAILED";
export const HTTP_RESET_BUDGETSTATUS = "HTTP_RESET_BUDGETSTATUS";

// // Budget Update Budget status
export const HTTP_UPDATEBUDGETSTATUS_FETCHING =
  "HTTP_UPDATEBUDGETSTATUS_FETCHING";
export const HTTP_UPDATEBUDGETSTATUS_SUCCESS =
  "HTTP_UPDATEBUDGETSTATUS_SUCCESS";
export const HTTP_UPDATEBUDGETSTATUS_FAILED = "HTTP_UPDATEBUDGETSTATUS_FAILED";

// // Update approve initail
export const HTTP_UPDATEINITIALAPPROVE_FETCHING =
  "HTTP_UPDATEINITIALAPPROVE_FETCHING";
export const HTTP_UPDATEINITIALAPPROVE_SUCCESS =
  "HTTP_UPDATEINITIALAPPROVE_SUCCESS";
export const HTTP_UPDATEINITIALAPPROVE_FAILED =
  "HTTP_UPDATEINITIALAPPROVE_FAILED";

// // Check get token
export const HTTP_CHECKGETTOKEN_FETCHING = "HTTP_CHECKGETTOKEN_FETCHING";
export const HTTP_CHECKGETTOKEN_SUCCESS = "HTTP_CHECKGETTOKEN_SUCCESS";
export const HTTP_CHECKGETTOKEN_FAILED = "HTTP_CHECKGETTOKEN_FAILED";

//-------------------SPECIAL OWNER ---------------------------------
// // Brand Query
export const HTTP_SELBRANDSPECIAL_FETCHING = "HTTP_SELBRANDSPECIAL_FETCHING";
export const HTTP_SELBRANDSPECIAL_SUCCESS = "HTTP_SELBRANDSPECIAL_SUCCESS";
export const HTTP_SELBRANDSPECIAL_FAILED = "HTTP_SELBRANDSPECIAL_FAILED";
// export const STOCK_CLEAR = "STOCK_CLEAR";
// // Company Query
export const HTTP_SELCOMPANYSPECIAL_FETCHING =
  "HTTP_SELCOMPANYSPECIAL_FETCHING";
export const HTTP_SELCOMPANYSPECIAL_SUCCESS = "HTTP_SELCOMPANYSPECIAL_SUCCESS";
export const HTTP_SELCOMPANYSPECIAL_FAILED = "HTTP_SELCOMPANYSPECIAL_FAILED";

// // Country Page
export const HTTP_COUNTRYSPECIAL_FETCHING = "HTTP_COUNTRYSPECIAL_FETCHING";
export const HTTP_COUNTRYSPECIAL_SUCCESS = "HTTP_COUNTRYSPECIAL_SUCCESS";
export const HTTP_COUNTRYSPECIAL_FAILED = "HTTP_COUNTRYSPECIAL_FAILED";

// // Department Page
export const HTTP_DEPARTMENTSPECIAL_FETCHING =
  "HTTP_DEPARTMENTSPECIAL_FETCHING";
export const HTTP_DEPARTMENTSPECIAL_SUCCESS = "HTTP_DEPARTMENTSPECIAL_SUCCESS";
export const HTTP_DEPARTMENTSPECIAL_FAILED = "HTTP_DEPARTMENTSPECIAL_FAILED";

// // Budget Get Special
export const HTTP_GETSPECIAL_FETCHING = "HTTP_GETSPECIAL_FETCHING";
export const HTTP_GETSPECIAL_SUCCESS = "HTTP_GETSPECIAL_SUCCESS";
export const HTTP_GETSPECIAL_FAILED = "HTTP_GETSPECIAL_FAILED";
export const HTTP_RESET_SPECIAL = "HTTP_RESET_SPECIAL";

// // Budget create special
export const HTTP_CREATESPECIAL_FETCHING = "HTTP_CREATESPECIAL_FETCHING";
export const HTTP_CREATESPECIAL_SUCCESS = "HTTP_CREATESPECIAL_SUCCESS";
export const HTTP_CREATESPECIAL_FAILED = "HTTP_CREATESPECIAL_FAILED";

// // Budget Update Special
export const HTTP_UPDATESPECIAL_FETCHING = "HTTP_UPDATESPECIAL_FETCHING";
export const HTTP_UPDATESPECIAL_SUCCESS = "HTTP_UPDATESPECIAL_SUCCESS";
export const HTTP_UPDATESPECIAL_FAILED = "HTTP_UPDATESPECIAL_FAILED";

// // Budget Delete Special
export const HTTP_DELETESPECIAL_FETCHING = "HTTP_DELETESPECIAL_FETCHING";
export const HTTP_DELETESPECIAL_SUCCESS = "HTTP_DELETESPECIAL_SUCCESS";
export const HTTP_DELETESPECIAL_FAILED = "HTTP_DELETESPECIAL_FAILED";

// // Budget Delete Special
export const HTTP_DELETESPECIALBYID_FETCHING =
  "HTTP_DELETESPECIALBYID_FETCHING";
export const HTTP_DELETESPECIALBYID_SUCCESS = "HTTP_DELETESPECIALBYID_SUCCESS";
export const HTTP_DELETESPECIALBYID_FAILED = "HTTP_DELETESPECIALBYID_FAILED";

export const LIST_PR_FETCH = "LIST_PR_FETCH";
export const LIST_PR_SUCCESS = "LIST_PR_SUCCESS";
export const LIST_PR_REJECTED = "LIST_PR_REJECTED";

export const LIST_USER_MANAGER_FETCH = "LIST_USER_MANAGER_FETCH";
export const LIST_USER_MANAGER_SUCCESS = "LIST_USER_MANAGER_SUCCESS";
export const LIST_USER_MANAGER_REJECTED = "LIST_USER_MANAGER_REJECTED";

export const LIST_PR_JOB_FETCH = "LIST_PR_JOB_FETCH";
export const LIST_PR_JOB_SUCCESS = "LIST_PR_JOB_SUCCESS";
export const LIST_PR_JOB_REJECTED = "LIST_PR_JOB_REJECTED";

export const GET_PR_FETCH = "GET_PR_FETCH";
export const GET_PR_SUCCESS = "GET_PR_SUCCESS";
export const GET_PR_REJECTED = "GET_PR_REJECTED";

export const GET_PR_REFCODE_FETCH = "GET_PR_REFCODE_FETCH";
export const GET_PR_REFCODE_SUCCESS = "GET_PR_REFCODE_SUCCESS";
export const GET_PR_REFCODE_REJECTED = "GET_PR_REFCODE_REJECTED";

export const GET_PR_JOB_FETCH = "GET_PR_JOB_FETCH";
export const GET_PR_JOB_SUCCESS = "GET_PR_JOB_SUCCESS";
export const GET_PR_JOB_REJECTED = "GET_PR_JOB_REJECTED";

export const GET_PR_JOB_ITEM_FETCH = "GET_PR_JOB_ITEM_FETCH";
export const GET_PR_JOB_ITEM_SUCCESS = "GET_PR_JOB_ITEM_SUCCESS";
export const GET_PR_JOB_ITEM_REJECTED = "GET_PR_JOB_ITEM_REJECTED";

export const GET_PR_JOB_EDIT_FETCH = "GET_PR_JOB_EDIT_FETCH";
export const GET_PR_JOB_EDIT_SUCCESS = "GET_PR_JOB_EDIT_SUCCESS";
export const GET_PR_JOB_EDIT_REJECTED = "GET_PR_JOB_EDIT_REJECTED";

export const GET_PR_DETAIL_FETCH = "GET_PR_DETAIL_FETCH";
export const GET_PR_DETAIL_SUCCESS = "GET_PR_DETAIL_SUCCESS";
export const GET_PR_DETAIL_REJECTED = "GET_PR_DETAIL_REJECTED";

export const GET_PR_EXPENSE_FETCH = "GET_PR_EXPENSE_FETCH";
export const GET_PR_EXPENSE_SUCCESS = "GET_PR_EXPENSE_SUCCESS";
export const GET_PR_EXPENSE_REJECTED = "GET_PR_EXPENSE_REJECTED";

export const GET_PR_EXPENSE_JOB_FETCH = "GET_PR_EXPENSE_JOB_FETCH";
export const GET_PR_EXPENSE_JOB_SUCCESS = "GET_PR_EXPENSE_JOB_SUCCESS";
export const GET_PR_EXPENSE_JOB_REJECTED = "GET_PR_EXPENSE_JOB_REJECTED";

export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_REJECTED = "UPDATE_EXPENSE_REJECTED";

//-------------------SPECIAL OWNER ---------------------------------

export const CREATE_PR_FETCH = "CREATE_PR_FETCH";
export const CREATE_PR_SUCCESS = "CREATE_PR_SUCCESS";
export const CREATE_PR_REJECTED = "CREATE_PR_REJECTED";

export const CREATE_PR_DETAIL_REMARK_SUCCESS =
  "CREATE_PR_DETAIL_REMARK_SUCCESS";
export const CREATE_PR_DETAIL_REMARK_REJECTED =
  "CREATE_PR_DETAIL_REMARK_REJECTED";
export const CREATE_PR_DETAIL_REMARK_CLEAR = "CREATE_PR_DETAIL_REMARK_CLEAR";

export const LIST_YEAR_FETCH = "LIST_YEAR_FETCH";
export const LIST_YEAR_SUCCESS = "LIST_YEAR_SUCCESS";
export const LIST_YEAR_REJECTED = "LIST_YEAR_REJECTED";

export const LIST_ASSIGNER_FETCH = "LIST_ASSIGNER_FETCH";
export const LIST_ASSIGNER_SUCCESS = "LIST_ASSIGNER_SUCCESS";
export const LIST_ASSIGNER_REJECTED = "LIST_ASSIGNER_REJECTED";

export const LIST_SUPPLIER_FETCH = "LIST_SUPPLIER_FETCH";
export const LIST_SUPPLIER_SUCCESS = "LIST_SUPPLIER_SUCCESS";
export const LIST_SUPPLIER_REJECTED = "LIST_SUPPLIER_REJECTED";

export const LIST_PR_DETAIL_REMARK_FETCH = "LIST_PR_DETAIL_REMARK_FETCH";
export const LIST_PR_DETAIL_REMARK_SUCCESS = "LIST_PR_DETAIL_REMARK_SUCCESS";
export const LIST_PR_DETAIL_REMARK_REJECTED = "LIST_PR_DETAIL_REMARK_REJECTED";

export const DELETE_PR_DETAIL_REMARK_SUCCESS =
  "DELETE_PR_DETAIL_REMARK_SUCCESS";
export const DELETE_PR_DETAIL_REMARK_REJECTED =
  "DELETE_PR_DETAIL_REMARK_REJECTED";
export const DELETE_PR_DETAIL_REMARK_CLEAR = "CREATE_PR_DETAIL_REMARK_CLEAR";

export const UPDATE_PR_FETCH = "UPDATE_PR_FETCH";
export const UPDATE_PR_SUCCESS = "UPDATE_PR_SUCCESS";
export const UPDATE_PR_CLEAR = "UPDATE_PR_CLEAR";
export const UPDATE_PR_REJECTED = "UPDATE_PR_REJECTED";

export const GET_PRODUCT_FETCH = "GET_PRODUCT_FETCH";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_REJECTED = "GET_PRODUCT_REJECTED";
export const GET_PRODUCT_CLEAR = "GET_PRODUCT_CLEAR";

export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_CLEAR = "ADD_PRODUCT_CLEAR";
export const ADD_PRODUCT_REJECTED = "ADD_PRODUCT_REJECTED";

export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_REJECTED = "DELETE_PRODUCT_REJECTED";

export const LIST_UNIT_FETCH = "LIST_UNIT_FETCH";
export const LIST_UNIT_SUCCESS = "LIST_UNIT_SUCCESS";
export const LIST_UNIT_REJECTED = "LIST_UNIT_REJECTED";

export const LIST_CURRENCY_FETCH = "LIST_CURRENCY_FETCH";
export const LIST_CURRENCY_SUCCESS = "LIST_CURRENCY_SUCCESS";
export const LIST_CURRENCY_REJECTED = "LIST_CURRENCY_REJECTED";

export const LIST_COUNTRIES_FETCH = "LIST_COUNTRIES_FETCH";
export const LIST_COUNTRIES_SUCCESS = "LIST_COUNTRIES_SUCCESS";
export const LIST_COUNTRIES_REJECTED = "LIST_COUNTRIES_REJECTED";

export const ADD_DETAIL_REMARK_JOB_SUCCESS = "ADD_DETAIL_REMARK_JOB_SUCCESS";
export const ADD_DETAIL_REMARK_JOB_CLEAR = "ADD_DETAIL_REMARK_JOB_CLEAR";
export const ADD_DETAIL_REMARK_JOB_REJECTED = "ADD_DETAIL_REMARK_JOB_REJECTED";

export const REMOVE_DETAIL_REMARK_JOB_SUCCESS =
  "REMOVE_DETAIL_REMARK_JOB_SUCCESS";
export const REMOVE_DETAIL_REMARK_JOB_CLEAR = "REMOVE_DETAIL_REMARK_JOB_CLEAR";
export const REMOVE_DETAIL_REMARK_JOB_REJECTED =
  "REMOVE_DETAIL_REMARK_JOB_REJECTED";

export const UPDATE_DETAIL_REMARK_JOB_SUCCESS =
  "UPDATE_DETAIL_REMARK_JOB_SUCCESS";
export const UPDATE_DETAIL_REMARK_JOB_CLEAR = "UPDATE_DETAIL_REMARK_JOB_CLEAR";
export const UPDATE_DETAIL_REMARK_JOB_REJECTED =
  "UPDATE_DETAIL_REMARK_JOB_REJECTED";

export const LIST_DETAIL_REMARK_JOB_FETCH = "LIST_DETAIL_REMARK_JOB_FETCH";
export const LIST_DETAIL_REMARK_JOB_SUCCESS = "LIST_DETAIL_REMARK_JOB_SUCCESS";
export const LIST_DETAIL_REMARK_JOB_REJECTED =
  "LIST_DETAIL_REMARK_JOB_REJECTED";

export const GET_COUNTRIES_FETCH = "GET_COUNTRIES_FETCH";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_REJECTED = "GET_COUNTRIES_REJECTED";

export const GET_REMARK_STATUS_FETCH = "GET_REMARK_STATUS_FETCH";
export const GET_REMARK_STATUS_SUCCESS = "GET_REMARK_STATUS_SUCCESS";
export const GET_REMARK_STATUS_REJECTED = "GET_REMARK_STATUS_REJECTED";

export const GET_USERS_FETCH = "GET_USERS_FETCH";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_REJECTED = "GET_USERS_REJECTED";

export const GET_USER_FETCH = "GET_USER_FETCH";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_REJECTED = "GET_USER_REJECTED";

export const SAVE_USER_SUCCESS = "SAVE_USER_SUCCESS";
export const SAVE_USER_REJECTED = "SAVE_USER_REJECTED";

export const GET_ROLES_FETCH = "GET_ROLES_FETCH";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_REJECTED = "GET_ROLES_REJECTED";

export const GET_ROLE_USER_FETCH = "GET_ROLE_USER_FETCH";
export const GET_ROLE_USER_SUCCESS = "GET_ROLE_USER_SUCCESS";
export const GET_ROLE_USER_REJECTED = "GET_ROLE_USER_REJECTED";

export const GET_DOA_ROLE_USER_FETCH = "GET_DOA_ROLE_USER_FETCH";
export const GET_DOA_ROLE_USER_SUCCESS = "GET_DOA_ROLE_USER_SUCCESS";
export const GET_DOA_ROLE_USER_REJECTED = "GET_DOA_ROLE_USER_REJECTED";

export const GET_DOA_ROLES_FETCH = "GET_DOA_ROLES_FETCH";
export const GET_DOA_ROLES_SUCCESS = "GET_DOA_ROLES_SUCCESS";
export const GET_DOA_ROLES_REJECTED = "GET_DOA_ROLES_REJECTED";

export const GET_ROLE_FETCH = "GET_ROLE_FETCH";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_ROLE_REJECTED = "GET_ROLE_REJECTED";

export const SAVE_ROLE_SUCCESS = "SAVE_ROLE_SUCCESS";
export const SAVE_ROLE_REJECTED = "SAVE_ROLE_REJECTED";

export const SAVE_ROLE_PERMISSION_SUCCESS = "SAVE_ROLE_PERMISSION_SUCCESS";
export const SAVE_ROLE_PERMISSION_REJECTED = "SAVE_ROLE_PERMISSION_REJECTED";

export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_REJECTED = "DELETE_ROLE_REJECTED";

export const GET_PERMISSIONS_FETCH = "GET_PERMISSIONS_FETCH";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_REJECTED = "GET_PERMISSIONS_REJECTED";

export const GET_PERMISSION_FETCH = "GET_PERMISSION_FETCH";
export const GET_PERMISSION_SUCCESS = "GET_PERMISSION_SUCCESS";
export const GET_PERMISSION_REJECTED = "GET_PERMISSION_REJECTED";

export const GET_DEPARTMENT_FETCH = "GET_DEPARTMENT_FETCH";
export const GET_DEPARTMENT_SUCCESS = "GET_DEPARTMENT_SUCCESS";
export const GET_DEPARTMENT_REJECTED = "GET_DEPARTMENT_REJECTED";

export const GET_BRAND_FETCH = "GET_BRAND_FETCH";
export const GET_BRAND_SUCCESS = "GET_BRAND_SUCCESS";
export const GET_BRAND_REJECTED = "GET_BRAND_REJECTED";

export const GET_PROJECT_FETCH = "GET_PROJECT_FETCH";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_REJECTED = "GET_PROJECT_REJECTED";

export const SAVE_PERMISSION_SUCCESS = "SAVE_PERMISSION_SUCCESS";
export const SAVE_PERMISSION_REJECTED = "SAVE_PERMISSION_REJECTED";

export const DELETE_PERMISSION_SUCCESS = "DELETE_PERMISSION_SUCCESS";
export const DELETE_PERMISSION_REJECTED = "DELETE_PERMISSION_REJECTED";

export const GET_LOCATION_FETCH = "GET_LOCATION_FETCH";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_REJECTED = "GET_LOCATION_REJECTED";

export const GET_BUDGET_MANAGEMENT_REPORT_FETCH =
  "GET_BUDGET_MANAGEMENT_REPORT_FETCH";
export const GET_BUDGET_MANAGEMENT_REPORT_SUCCESS =
  "GET_BUDGET_MANAGEMENT_REPORT_SUCCESS";
export const GET_BUDGET_MANAGEMENT_REPORT_REJECTED =
  "GET_BUDGET_MANAGEMENT_REPORT_REJECTED";
export const GET_BUDGET_MANAGEMENT_REPORT_CLEAR =
  "GET_BUDGET_MANAGEMENT_REPORT_CLEAR";

export const GET_BUDGET_ADJ_REMAIN_REPORT_FETCH =
  "GET_BUDGET_ADJ_REMAIN_REPORT_FETCH";
export const GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS =
  "GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS";
export const GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED =
  "GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED";
export const GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR =
  "GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR";

// // Budget get BUDGETFA
export const HTTP_GETBUDGETFA_FETCHING = "HTTP_GETBUDGETFA_FETCHING";
export const HTTP_GETBUDGETFA_SUCCESS = "HTTP_GETBUDGETFA_SUCCESS";
export const HTTP_GETBUDGETFA_FAILED = "HTTP_GETBUDGETFA_FAILED";
export const HTTP_RESET_GETBUDGETFA = "HTTP_RESET_GETBUDGETFA";

// // Budget Update BUDGETFA
export const HTTP_UPDATEBUDGETFA_FETCHING = "HTTP_UPDATEBUDGETFA_FETCHING";
export const HTTP_UPDATEBUDGETFA_SUCCESS = "HTTP_UPDATEBUDGETFA_SUCCESS";
export const HTTP_UPDATEBUDGETFA_FAILED = "HTTP_UPDATEBUDGETFA_FAILED";
export const HTTP_RESET_UPDATEBUDGETFA = "HTTP_RESET_UPDATEBUDGETFA";

// // Budget Load BUDGETFA
export const HTTP_LOADBUDGETFA_FETCHING = "HTTP_LOADBUDGETFA_FETCHING";
export const HTTP_LOADBUDGETFA_SUCCESS = "HTTP_LOADBUDGETFA_SUCCESS";
export const HTTP_LOADBUDGETFA_FAILED = "HTTP_LOADBUDGETFA_FAILED";
export const HTTP_RESET_LOADBUDGETFA = "HTTP_RESET_LOADBUDGETFA";

//------------------ Budget Compare Report ---------------
//--------------------------------------------------------

// // Budget get BUDGET Compare sum by brand
export const HTTP_GETBUDGETCOMPSBYBRAND_FETCHING =
  "HTTP_GETBUDGETCOMPSBYBRAND_FETCHING";
export const HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS =
  "HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS";
export const HTTP_GETBUDGETCOMPSBYBRAND_FAILED =
  "HTTP_GETBUDGETCOMPSBYBRAND_FAILED";
export const HTTP_RESET_GETBUDGETCOMPSBYBRAND =
  "HTTP_RESET_GETBUDGETCOMPSBYBRAND";

// // Budget get BUDGET Compare Detail by brand
export const HTTP_GETBUDGETCOMPDBYBRAND_FETCHING =
  "HTTP_GETBUDGETCOMPDBYBRAND_FETCHING";
export const HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS =
  "HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS";
export const HTTP_GETBUDGETCOMPDBYBRAND_FAILED =
  "HTTP_GETBUDGETCOMPDBYBRAND_FAILED";
export const HTTP_RESET_GETBUDGETCOMPDBYBRAND =
  "HTTP_RESET_GETBUDGETCOMPDBYBRAND";

// // Budget get BUDGET Compare sum by Department
export const HTTP_GETBUDGETCOMPSBYDEPT_FETCHING =
  "HTTP_GETBUDGETCOMPSBYDEPT_FETCHING";
export const HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS =
  "HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS";
export const HTTP_GETBUDGETCOMPSBYDEPT_FAILED =
  "HTTP_GETBUDGETCOMPSBYDEPT_FAILED";
export const HTTP_RESET_GETBUDGETCOMPSBYDEPT =
  "HTTP_RESET_GETBUDGETCOMPSBYDEPT";

// // Budget get BUDGET Compare Detail by Department
export const HTTP_GETBUDGETCOMPDBYDEPT_FETCHING =
  "HTTP_GETBUDGETCOMPDBYDEPT_FETCHING";
export const HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS =
  "HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS";
export const HTTP_GETBUDGETCOMPDBYDEPT_FAILED =
  "HTTP_GETBUDGETCOMPDBYDEPT_FAILED";
export const HTTP_RESET_GETBUDGETCOMPDBYDEPT =
  "HTTP_RESET_GETBUDGETCOMPDBYDEPT";

export const LOGIN_STATUS = "LOGIN_STATUS";

// // Budget get Month for copy
export const HTTP_GETMONTHBUDGET_FETCHING = "HTTP_GETMONTHBUDGET_FETCHING";
export const HTTP_GETMONTHBUDGET_SUCCESS = "HTTP_GETMONTHBUDGET_SUCCESS";
export const HTTP_GETMONTHBUDGET_FAILED = "HTTP_GETMONTHBUDGET_FAILED";
export const HTTP_RESET_GETMONTHBUDGET = "HTTP_RESET_GETMONTHBUDGET";

// // Budget copy budget
export const HTTP_COPYMONTHBUDGET_FETCHING = "HTTP_COPYMONTHBUDGET_FETCHING";
export const HTTP_COPYMONTHBUDGET_SUCCESS = "HTTP_COPYMONTHBUDGET_SUCCESS";
export const HTTP_COPYMONTHBUDGET_FAILED = "HTTP_COPYMONTHBUDGET_FAILED";
export const HTTP_RESET_COPYMONTHBUDGET = "HTTP_RESET_COPYMONTHBUDGET";

export const server = {
  LOGIN_URL: `authen/login`,
  // REGISTER_URL: `authen/register`,
  CHECKTOKEN_URL: `authen/checktoken`,
  EXPENSE_URL: `budget/expense`,
  INVESTMENT_URL: `budget/investment`,
  YEAR_URL: `budget/expense/selectyear`,
  GETBUDGETSDETAIL_URL: `budget/expense/budgetsdetail`,
  BRAND_URL: `authen/brands`,
  COMPANY_URL: `budget/expense/selectcompany`,
  COUNTRY_URL: `budget/expense/selectcountry`,
  DEPART_URL: `budget/expense/selectdept`,
  BUDGETS_URL: `budget/expense/budgets`,
  USERAUTH_URL: `budget/userauth`,
  BUDGETMONTH_URL: `budget/expense/budgetmonth`,
  UPDATEBUDGETMONTH_URL: `budget/expense/updatebudgetmonth`,
  INSERTBUDGETS_URL: `budget/expense/insertbudgets`,
  INSERTPROJECT_URL: `budget/investment/project`,
  GETPROJECT_URL: `budget/investment/project`,
  GETPROJECTDETAIL_URL: `budget/investment/project-detail`,
  UPDATEPROJECT_URL: `budget/investment/project`,
  DELETEPROJECT_URL: `budget/investment/project`,
  UPDATEPROJECTDETAIL_URL: `budget/investment/project-detail`,
  GETFILETEMP_URL: `budget/getfile/reportfinalbudget`,
  GETBUHEADLIST_URL: `budget/expense/getbuheadlist`,
  UPDATEBUHEAD_URL: `budget/expense/updatebuhead`,
  GETAPPROVE_URL: `budget/approve/approve-list`,
  UPDATEAPPROVE_URL: `budget/approve/approve-update`,
  REJECTAPPROVE_URL: `budget/approve/approve-update-reject`,
  GETAPPROVEHISTORY_URL: `budget/approve/approve-list-history`,
  REPORTMANAGERBYBRAND_URL: `budget/manager-report/report-bybrand`,
  REPORTMANAGERBYDEPARTMENT_URL: `budget/manager-report/report-bydepts`,
  REPORTBUDGETSDETAIL_URL: `budget/manager-report/report-budgetdetailbybrand`,
  SENDMAILBUHEAD_URL: `budget/expense/buheadsendmail`,
  GETFORECAST1_URL: `budget/forecast/forecast-list1`,
  GETFORECAST2_URL: `budget/forecast/forecast-list2`,
  GETFORECAST3_URL: `budget/forecast/forecast-list3`,
  GETFORECAST4_URL: `budget/forecast/forecast-list4`,
  GETFORECAST5_URL: `budget/forecast/forecast-list5`,
  UPDATEFORECAST_URL: `budget/forecast/forecast-update`,
  UPDATEINITIALAPPROVE_URL: `budget/approve/approve-updateinitial`,
  // GETBUDGETSTATUS_URL: `budget/budgetstatus/budget-status`,
  // UPDATEBUDGETSTATUS_URL: `budget/budgetstatus/update-budgetstatus`,

  //----------Special Owner ----------------------
  // Done
  COUNTRYSPECIAL_URL: `budget/special/countries`,
  COMPANYSPECIAL_URL: `budget/special/companies-country`,
  BRANDSPECIAL_URL: `budget/special/brands-company`,
  DEPARTSPECIAL_URL: `budget/special/department-brand`,
  GETSPECIAL_URL: `budget/special/specialowner`,
  CREATESPECIAL_URL: `budget/special/specialowner`,
  UPDATESPECIAL_URL: `budget/special/specialowner`,
  // Done
  DELETESPECIAL_URL: `budget/special/delete-specialowner`,
  DELETESPECIALBYID_URL: `budget/special/delete-specialowner`,
  LOGIN_PASSED: `yes`,

  //------------------ BudgetForecast Monthly ---------------
  //--------------------------------------------------------
  GETBUDGETFA_URL: `budget/forecastMonthly/budgetfa-h`,
  LOADBUDGETFA_URL: `budget/forecastMonthly/budgetfa`,
  UPDATEBUDGETFA_URL: `budget/forecastMonthly/budgetfa`,
  GETMONTHBUDGET_URL: `budget/forecastMonthly/getmonth-copy`,
  COPYMONTHBUDGET_URL: `budget/forecastMonthly/getmonth-copy`,
  //------------------ Budget Compare Report ---------------
  //--------------------------------------------------------
  GETBUDGETCOMPBYBRANDS_URL: `budget/budgetcompare-report/report-comparesbybrand`,
  GETBUDGETCOMPBYBRANDD_URL: `budget/budgetcompare-report/report-comparedbybrand`,
  GETBUDGETCOMPBYDEPTS_URL: `budget/budgetcompare-report/report-comparesbydepts`,
  GETBUDGETCOMPBYDEPTD_URL: `budget/budgetcompare-report/report-comparedbydepts`,
};

// Error Code
export const E_PICKER_CANCELLED = "E_PICKER_CANCELLED";
export const E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR =
  "E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR";
export const E_PERMISSION_MISSING = "E_PERMISSION_MISSING";
export const E_PICKER_NO_CAMERA_PERMISSION = "E_PICKER_NO_CAMERA_PERMISSION";
export const E_USER_CANCELLED = "E_USER_CANCELLED";
export const E_UNKNOWN = "E_UNKNOWN";
export const E_DEVELOPER_ERROR = "E_DEVELOPER_ERROR";
export const TIMEOUT_NETWORK = "ECONNABORTED"; // request service timeout
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  "An error has occurred. The photo was unable to upload.";
